<div>

  <div class="pop-bg">
  </div>
  <div class="pop-position">
    <div class="modal readview-count-popup in border-radius-25" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
      style="display: block;">
      <div class="modal-dialog modal-md modal-bottom popup-width white count-list-popup-b border-radius-25" role="document">
        <div class="modal-content white mb-0 pb-0 border-radius-25" style="width:100%">
          <div class="row col-md-12 p-0 grey header-popup-box">
            <span class="col-md-10 col-sm-10 p-0">
              <div class="heading-panel sT-hight pl-10">
                <span class="text-sm text-ellipsis heading-txt flex ml-10">ACKNOWLEDGEMENT SUMMARY</span>
              </div>
            </span>
            <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor pe-none" (click)="toggleModel()">
              <i class="fa fa-times pe-all" aria-hidden="true"></i>
            </span>
          </div>
          <div  id="allCounts" class="col-md-12 col-sm-12 col-xs-12 p-0 d-flex mt-10" style="padding: 1rem">
            <ng-container *ngFor="let item of allCounts">
            <div class="col-md-4 col-sm-4 col-xs-4 p-0" [ngClass]="'count-type-' + item.Action">
              <span class="buckets-list-cl d-unset">
                  <b class="badge circle-buget  badge-sm badge-pill"> {{item.Action}} - {{item.Count}} </b>
                </span>
              </div>
            </ng-container>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 p-0 mt-10" style="padding: 1rem">
            <label style="float: right;"
              class="export-btn label blue btn-text label-info square-btn cursor mt-0 pull-right mr-5 btn-default"
              (click)="ExportToExcel()">
              <i class="fa fa-file-excel-o mr-5" aria-hidden="true"></i>Export To Excel</label>
          </div>
          <div class="col-md-12 p-0 mt-10">

            <div class="acc-popup-table sticky-table sticky-ltr-cells popup-table-height">
              <ag-grid-angular [enableSorting]="true" [enableColResize]="true" [enableFilter]="true" [pagination]="true"
                [paginationPageSize]="15" class="ag-theme-balham grid-w" [rowData]="rowData" [columnDefs]="columnDefs"
                [suppressDragLeaveHidesColumns]="true" [suppressDragLeaveHidesColumns]="true"
                [rowSelection]="rowSelection" (gridReady)="onGridReady($event)" [suppressColumnVirtualisation]="true">
              </ag-grid-angular>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>
